import React, { FC, useState } from 'react'
import { DEFAULT_INTRO_MESSAGE, DEFAULT_SEND_TO } from './constants'
import {
  IConfigObj,
  IConversation,
  IError,
  ILoadingObj,
  ISendToObj,
  IUserObj,
  StoreContextType,
} from './types'

interface props {
  children: any
}

const Store = () => {
  const [isInit, setIsInit] = useState(false)
  const [message, setMessage] = useState('')
  const [ws, setWs] = useState<WebSocket | null>(null)
  const [selectedConversation, setSelectedConversation] = useState('')
  const [conversationList, setConversationList] = useState<IConversation[]>([])
  const [objConfig, setObjConfig] = useState<IConfigObj | null>(null)
  const [errors_, setErrors_] = useState<IError[]>([])
  const [loading, setLoading] = useState<ILoadingObj>({
    conversations: false,
    messages: false,
    faq: false,
  })
  const [introMessage, setIntroMessage] = useState(DEFAULT_INTRO_MESSAGE)
  const [userObj, setUserObj] = useState<IUserObj>({
    firstName: '',
    lastName: '',
  })
  const [hasUnread, setHasUnread] = useState(false)
  const [isTyping, setIsTyping] = useState(false)
  const [forceUpdate, setForceUpdate] = useState(false)
  const [sendToReceipients, setSendToReceipients] =
    useState<ISendToObj>(DEFAULT_SEND_TO)
  const [faqBody, setFaqBody] = useState('')

  const init = { isInit, setIsInit }
  const websocket = { instance: ws, setInstance: setWs }
  const inputMessage = { message, setMessage }
  const conversations = { conversationList, setConversationList }
  const config = { objConfig, setObjConfig }
  const errors = { errors: errors_, setErrors: setErrors_ }
  const selectConversation = { selectedConversation, setSelectedConversation }
  const loadings = { loading, setLoading }
  const intro = { introMessage, setIntroMessage }
  const name = { userObj, setUserObj }
  const unread = { hasUnread, setHasUnread }
  const typing = { isTyping, setIsTyping }
  const force = { forceUpdate, setForceUpdate }
  const sendTo = { sendToReceipients, setSendToReceipients }
  const faq = { faqBody, setFaqBody }

  const value = {
    init,
    websocket,
    inputMessage,
    selectConversation,
    conversations,
    config,
    errors,
    loadings,
    intro,
    name,
    unread,
    typing,
    force,
    sendTo,
    faq,
  }

  return value
}

export const StoreContext = React.createContext<StoreContextType | null>(null)
export const WOStoreContext = React.createContext<StoreContextType | null>(null)

export const StoreProvider: FC<props> = ({ children }) => {
  const store = Store()

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}

export const WOStoreProvider: FC<props> = ({ children }) => {
  const store = Store()

  return (
    <WOStoreContext.Provider value={store}>{children}</WOStoreContext.Provider>
  )
}

export default { StoreContext, WOStoreContext, StoreProvider, WOStoreProvider }
